
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/labyrinth",
      function () {
        return require("private-next-pages/projects/labyrinth/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/labyrinth"])
      });
    }
  